.select {
  margin-top: var(--spacingXl);
}

.info {
  margin-top: var(--spacingXl);
  display: flex;
  flex-direction: column;
}
